import { useEffect } from 'react';
import config from '@plone/volto/registry';
import { CONSENTIMENTO_ALTERADO, consentiuEstatistica } from './CookieBanner';

// Estatística de uso (Google Analytics, pela tag do Google). Carrega só quando:
// 1. o endereço é o do site oficial (config.settings.googleTagHosts), para o
//    ambiente de desenvolvimento não mandar visitas à propriedade real; e
// 2. o visitante aceitou a categoria "Estatística" no aviso de cookies (LGPD).
// Se o visitante recusar depois, em "Gerenciar Cookies", a coleta para e os
// cookies do Analytics são apagados. Sem uso de dados para anúncios.

const CARREGADA = '__agTagGoogle';

export const carregar = (id) => {
  if (window[CARREGADA]) {
    window.gtag('consent', 'update', { analytics_storage: 'granted' });
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtagGlobal() {
    // a tag do Google lê o objeto arguments, não um array
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  window.gtag('consent', 'default', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
  window.gtag('js', new Date());
  window.gtag('config', id);
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  s.setAttribute('data-ag-tag-google', id);
  document.head.appendChild(s);
  window[CARREGADA] = true;
};

export const desligar = () => {
  if (window[CARREGADA] && window.gtag) {
    window.gtag('consent', 'update', { analytics_storage: 'denied' });
  }
  // apaga os cookies do Analytics (_ga e _ga_*) neste domínio e no principal
  const dominios = ['', `;domain=${window.location.hostname}`];
  const partes = window.location.hostname.split('.');
  if (partes.length > 2)
    dominios.push(`;domain=.${partes.slice(-3).join('.')}`);
  document.cookie
    .split(';')
    .map((c) => c.split('=')[0].trim())
    .filter((nome) => nome === '_ga' || nome.startsWith('_ga_'))
    .forEach((nome) =>
      dominios.forEach((d) => {
        document.cookie = `${nome}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${d}`;
      }),
    );
};

const Analytics = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const { googleTagId, googleTagHosts = [] } = config.settings;
    if (!googleTagId || !googleTagHosts.includes(window.location.hostname)) {
      return undefined;
    }
    const aplicar = () => {
      if (consentiuEstatistica()) carregar(googleTagId);
      else desligar();
    };
    aplicar();
    window.addEventListener(CONSENTIMENTO_ALTERADO, aplicar);
    return () => window.removeEventListener(CONSENTIMENTO_ALTERADO, aplicar);
  }, []);
  return null;
};

export default Analytics;
